<template>
	<el-dialog title="jjj" :visible.sync="dialogVisible" width="300px" class="closedProp" :close-on-click-modal="false" :modal="false">
		<div class="flex-text">
			<i class="iconfont icontishichuang2" style="color:#fff;font-size: 28px;vertical-align: middle;margin-right: 5px;"></i>
			<!-- <img src="../../assets/img/tanchuang/icon-1.png" alt=""> --> {{tips}}
		</div>
	</el-dialog>
</template>

<script>
	export default {
		name:'ClosedProp',
		props:{
			tips:{
				type:String,
				default:'删除成功'
			}
		},
		data(){
			return{
				dialogVisible: false
			}
		},
		watch:{
			dialogVisible: {
				handler: function(val, oldval) {
					if (val) {
						setTimeout(()=>{
							this.dialogVisible = false
						},2000)
					}
				},
				deep: true //对象内部的属性监听，也叫深度监听
			}
		}
	}
</script>

<style lang="less">
	.closedProp{
		// background-color: #fff;
		.el-dialog__header{
			display: none;
		}
		.el-dialog{
				background-color: #000000;
				opacity: 0.8;
		}
		.flex-text{
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.el-dialog__body{
			// background-color: #000000;
				// border-radius: 4px;
				// opacity: 0.5;
				font-family: MicrosoftYaHei;
					font-size: 16px;
					font-weight: normal;
					font-stretch: normal;
					
					letter-spacing: 1px;
					color: #ffffff;
					text-align: center;
		}
		.el-dialog .el-dialog__body{
			padding: 26px;
		}
	}
</style>
